import { Map } from 'immutable';

import { unwrap } from './ChangeSpy';

/**
 * Get value of a select option that may be an Immutable option ({ name, value }) or already a raw value.
 *
 * @param option {*} Option (may be wrapped by ChangeSpy).
 * @returns {*} Option value.
 */
const getOptionValue = option => {
  const unwrapped = unwrap(option);

  return Map.isMap(unwrapped) ? unwrapped.get('value') : unwrapped ?? null;
};

export default getOptionValue;
